import { api } from './api';

export const launchFundamentalAnalysis = () =>
  api.post('sso/fundamental-analysis/launch').then((r) => r.data);
